// src/theme/tokens.ts
// 単一の情報源（Single source of truth）としてのデザイントークン。
// 画面側でハードコードしていた色は、原則ここ or theme.palette から参照する。

export const colors = {
    // 面（奥行きを層で表現）
    bg: '#0E1116', // 最背面（深インク）
    surface: '#161B22', // カード等
    surfaceHigh: '#1C222B', // ホバー/上位面
    surfaceHigher: '#232B36', // メニュー/ポップオーバー

    // ブランドのゴールド（達成・CTA・フォーカスにのみ節度を持って）
    gold: '#E4B95B',
    goldBright: '#F0CE7E',
    goldDeep: '#C9A227',
    goldSoft: 'rgba(228,185,91,0.14)', // 罫線・微光

    // テキスト
    textPrimary: '#F2F4F8',
    textSecondary: '#9AA4B2',
    textDisabled: '#5B6472',

    // 意味色
    success: '#4CAF7D',
    error: '#E5484D',
    warning: '#E4B95B',
    info: '#5AA0C4',

    // 罫線
    border: 'rgba(228,185,91,0.14)',
    borderNeutral: 'rgba(255,255,255,0.08)',
} as const;

// モーションの共通トークン（framer-motion / CSS 双方で使う）
export const motion = {
    // イージング（上質なスローイン・アウト）
    ease: [0.22, 1, 0.36, 1] as [number, number, number, number], // easeOutQuint 相当
    easeCss: 'cubic-bezier(0.22, 1, 0.36, 1)',
    duration: {
        fast: 0.18,
        base: 0.32,
        slow: 0.6,
    },
} as const;

// 影（ネオン発光ではなく、柔らかい落ち影＋微かな金の縁）
export const shadows = {
    card: '0 1px 2px rgba(0,0,0,0.4), 0 8px 24px rgba(0,0,0,0.28)',
    cardHover: '0 2px 4px rgba(0,0,0,0.45), 0 16px 40px rgba(0,0,0,0.36)',
    goldGlow: '0 0 0 1px rgba(228,185,91,0.35), 0 8px 30px rgba(228,185,91,0.18)',
} as const;

export const radius = {
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    pill: 999,
} as const;
